import React from 'react';
import { CreateProductView } from './CreateProductView';
import { useCreateProductForm } from './useCreateProductForm';
import { getNodeTestIdProp } from '@/utils';

/**
 * /products/new — the create-product form. Builds the whole Product → Variant →
 * Batch graph and POSTs it in one round-trip (`useCreateProductForm`), then
 * navigates to the new product's detail page. Unlike the tables this page has
 * no `ErrorBoundary`: load/submit problems surface inline (the picker queries
 * degrade to empty option lists; the server's 400 text shows under the form).
 */
export const CreateProduct: React.FC = () => {
    const form = useCreateProductForm();

    return (
        <div
            className="flex w-full flex-col gap-8"
            {...getNodeTestIdProp('create-product-page')}
            id="create-product-page"
        >
            <CreateProductView form={form} />
        </div>
    );
};
